import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Injector } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { Title } from '@angular/platform-browser';

// eslint-disable-next-line no-restricted-imports, import/order
import { IdtFragmentsLayoutPipe } from 'cms/cms-shared/pipes/fragmentsLayout.pipe';

import { setInjector } from 'shared/app.injector';
import { IdtLetDirective } from 'shared/directives/idt-let.directive';
import { DynamicIdtComponentResolutionPipe } from 'shared/dynamic/dynamic-idt-component-resolution.pipe';
import { DynamicIdtComponentService } from 'shared/dynamic/dynamic-idt-component.service';
import { EmbedVideoService } from 'shared/embed-video/embed-video.service';
import { IdtCapitalizePipe } from 'shared/pipes/capitalize.pipe';
import { IsCurrentPriceOnSalePipe } from 'shared/pipes/current-price-on-sale.pipe';
import { IdtExtractUnitPipe, IdtExtractUnitWithDefaultPipe } from 'shared/pipes/extract-unit.pipe';
import { IdtHtmlFalse } from 'shared/pipes/html-false.pipe';
import { IsDefinedPipe } from 'shared/pipes/is-defined.pipe';
import { IdtParsePipe } from 'shared/pipes/parse.pipe';
import { IdtRoundPipe } from 'shared/pipes/round.pipe';
import { IdtStripHtmlTagsPipe } from 'shared/pipes/strip-html-tags.pipe';
import { IdtStripNonNumericPipe, IdtStripNonNumericWithDefaultPipe } from 'shared/pipes/strip-non-numeric.pipe';
import { IdtTransFromISOPipe } from 'shared/pipes/transform-to-iso.pipe';
import { IdtTrustHtmlPipe } from 'shared/pipes/trust-html.pipe';
import { AssetsSharedService } from 'shared/services/assets-shared.service';
import { DatesService } from 'shared/services/dates/dates.service';
import { LinksService } from 'shared/services/links.service';
import { ScrollService } from 'shared/services/scroll.service';
import { SegmentationService } from 'shared/services/segmentation.service';
import { SharedConfigurationService } from 'shared/services/shared-configuration.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IdtCapitalizePipe,
    IdtRoundPipe,
    IdtTrustHtmlPipe,
    IdtStripHtmlTagsPipe,
    IdtTransFromISOPipe,
    IdtParsePipe,
    IdtFragmentsLayoutPipe,
    IdtHtmlFalse,
    DynamicIdtComponentResolutionPipe,
    IdtStripNonNumericPipe,
    IdtStripNonNumericWithDefaultPipe,
    IdtExtractUnitPipe,
    IdtExtractUnitWithDefaultPipe,
    IsDefinedPipe,
    IdtLetDirective,
    IsCurrentPriceOnSalePipe
  ],
  declarations: [
    IdtCapitalizePipe,
    IdtRoundPipe,
    IdtTrustHtmlPipe,
    IdtStripHtmlTagsPipe,
    IdtTransFromISOPipe,
    IdtParsePipe,
    IdtFragmentsLayoutPipe,
    IdtHtmlFalse,
    DynamicIdtComponentResolutionPipe,
    IdtStripNonNumericPipe,
    IdtStripNonNumericWithDefaultPipe,
    IdtExtractUnitPipe,
    IdtExtractUnitWithDefaultPipe,
    IsDefinedPipe,
    IdtLetDirective,
    IsCurrentPriceOnSalePipe
  ],
  providers: [
    DynamicIdtComponentService,
    AssetsSharedService,
    EmbedVideoService,
    LinksService,
    DatesService,
    SegmentationService,
    Title,
    ScrollService,
    SharedConfigurationService
  ],
})
export class SharedModule {

  constructor(injector: Injector) {
    setInjector(injector);
  }

}
